import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType";
import { showPopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";
import { SN_SYS_BAS_REG_008_POP_001 } from "@menu/SYS/SN_SYS_BAS_REG_008/SN_SYS_BAS_REG_008_POP_001"; // 공통 Interface

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_SYS_BAS_REG_008 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global();
  const searchRef = useRef<any>(null);
  const gridApiRef = useRef<any>(null);
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [dataSource, setDataSource] = useState<any>();

  //#endregion

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  useEffect(() => {
    const fetchform = async () => {
      setDataSource([]);
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);
  //#endregion

  const onSearch = async () => {
    const modifiedRows = gridApiRef.current.getChange();
    if (modifiedRows.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }

    try {
      const searchData = searchRef.current.getFormdata();
      if (!searchData || !searchData.cd_menu) {
        await showDialog("alter", "메뉴코드를 넣어주시기 바랍니다.");
        return;
      }

      const params = {
        id: "sn_sys_bas_reg_008_01",
        params: searchRef.current.getFormdata(),
      };

      setDataSource([]);
      const data: any = await fnGetDataSet(params);
      setDataSource(data[0]);

      if (data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        gridApiRef.current.selectAndFocusRow(0);
      }

      gridApiRef.current.resetUpdate();
    } catch (error: any) {}
  };

  const onInsert = async () => {
    try {
      const menuCode: String = searchRef.current.getFormdata().cd_menu;

      if (menuCode === "") {
        showDialog("alter", "메뉴코드를 넣어주시기 바랍니다.");
        return;
      }

      const newRow = {};
      gridApiRef.current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onBeforeAddRow = (newRow: RowData): boolean => {
    try {
      const allRowData: any[] = [];

      gridApiRef.current.api.forEachNode((node: any) => {
        allRowData.push(node.data);
      });
      const cd_menu = searchRef.current.getFormdata().cd_menu;
      const filteredRows = allRowData.filter(
        (row: any) => row.cd_menu === cd_menu
      );
      const maxNoLine =
        filteredRows.length > 0
          ? Math.max(...filteredRows.map((row: any) => row.no_line || 0))
          : 0;

      const maxSeq =
        filteredRows.length > 0
          ? Math.max(...filteredRows.map((row: any) => row.maxSeq || 0))
          : 0;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_menu: cd_menu,
        cd_form: "search",
        cd_module: "",
        no_line: maxNoLine + 1,
        cd_user: "admin",
        tp_ctrl: "SnTextBox",
        qt_rowindex: 1,
        qt_rowspan: 1,
        qt_colindex: 1,
        qt_colspan: 1,
        nm_label: "",
        cd_param: "",
        fg_visible: "Y",
        no_seq: maxSeq + 1,
        yn_required: "N",
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    gridApiRef.current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridApiRef.current.api.stopEditing();
      const requiredValuesCheckH = gridApiRef.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      const changesRow = gridApiRef.current.getChange();

      if (changesRow?.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const SaveData = {
        sys_popupctrl: changesRow,
      };

      const response = await fnSave("SN_SYS_BAS_REG_008_SAVE_01", SaveData);

      gridApiRef.current?.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnQuery") {
      const searchData = searchRef.current.getFormdata();
      if (!searchData || !searchData.cd_menu) {
        await showDialog("alter", "메뉴코드를 넣어주시기 바랍니다.");
        return;
      }

      const component = (
        <SN_SYS_BAS_REG_008_POP_001
          selectedData={gridApiRef.current.getCheckedRows()}
          allRowCount={dataSource.length}
        />
      );
      const result = await showPopupModal({
        title: "쿼리추출 도움창",
        children: component,
        okayBtn: false,
      });
      if (result === "close") return;
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div style={{ height: "calc(90%)" }}>
        <SnGrid
          
          seq={1}
          ref={gridApiRef}
          enableAddRow={true}
          columnConfig={columns}
          rowData={dataSource}
          enableExternalChart={false}
          isEditable={true}
          rowSelection="single"
          ischeckboxSelection={true}
          onBeforeAddRow={onBeforeAddRow}
          title="컨트롤정보"
          header={
            <div>
              <SnButton
                text={"쿼리추출"}
                onClick={() => {
                  onGrid1BtnsClick("btnQuery");
                }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
});

export default SN_SYS_BAS_REG_008;
